module.exports = __webpack_public_path__ + "media/images/header_sp-9636c99a72eb7af2181b96aa50cc378c.jpg";